<template>
    <div style="padding:0 20px;">
      <h1>贵族与付费订阅服务协议</h1>
      <p class="bold">发布日期：2026年7月1日</p>
      <p class="bold">重要提示</p>
      <!-- <p>
        欢迎使用由武汉稻荣之科技有限公司及其关联方（以下简称“我们”）提供的花漾（以下简称“平台”）贵族与付费订阅服务（以下简称“付费服务”）。
      </p> -->
      <p class="bold">
        您确认：您是具备完全民事权利能力和完全民事行为能力的自然人、法人或其他组织，有能力对您使用付费服务的一切行为独立承担责任。未成年人或因年龄、智力等因素而不具有完全民事行为能力的人，请在父母或监护人的陪同下阅读和判断是否同意本协议。若您的监护人同意您订购付费服务，则应当以监护人的名义完成交易。您同意协议，或对付费服务进行购买或使用即视为您已获得了监护人的认可。
      </p>
      <p class="bold">
        除非您已阅读并接受本协议所有条款，否则您无权使用付费服务。您同意协议，或对付费服务进行购买或使用即视为您已阅读并同意接受本协议的约束。
      </p>
      <p>
        <span class="bold">请仔细阅读本协议中以黑体加粗、下划线、颜色标记或以其他合理方式提示您注意的条款，该等条款可能与您的权益有重大利害关系，包括但不限于相关约定责任的条款、约定双方权利义务的条款、约定争议解决方式和司法管辖的条款等。</span>如果您认为该等条款可能导致您在特定情况下部分或全部利益或权利受损，请您在确认同意本协议之前或在使用本服务之前务必再次阅读前述条款，并在您自愿接受该等条款的前提下使用本服务
      </p>
      <p class="bold">
        本协议及相关服务条款如由于业务发展需要进行修订的，我们将在平台公布。您可前往查阅最新版协议条款。在我们修改上述条款后，如果您不接受修改后的条款，您可以选择终止使用付费服务。您继续使用本服务的，将被视为已接受了修改后的协议
      </p>
       <p>
        第一条 服务协议的接受和修订
       </p>
       <p>
        1.1 本协议是我们与您之间关于获取或使用付费服务的约定，为《用户协议》《内容生产服务协议》《充值服务协议》《隐私政策》等平台协议和平台政策的补充协议。如本协议与上述协议存在冲突的，以本协议约定为准。本协议未尽事宜，以上述其他协议约定为准。我们已经发布的或将来可能发布/更新的各类付费服务相关的规则，包括活动规则、权益说明、公告等均为本协议不可分割的组成部分，上述内容一经正式发布即生效，对双方均具约束力。
       </p>
       <p>
        第二条 付费服务内容
       </p>
       <p>
        2.1 付费服务，是指我们为您提供的网络增值服务，包括超级玩家等现有以及未来新增/调整的服务类型（具体服务类型以页面展示为准）。
       </p>
       <p>
        您在购买付费服务后可以依本协议以及页面展示的权益内容享有一定的特权，具体权益内容以我们提供的为准。账号的所有权和运营权，以及付费服务制度和活动的制订权均归我们所有。
       </p>
       <p>
        2.2 请您注意，各类服务的权益、单价、适用终端等服务内容可能存在差异，不同终端的权益、价格、内容可能存在差异，请在购买前仔细确认您所购买的付费服务。
       </p>
       <p>
        2.3 请您理解，我们有权根据法律法规、监管政策变化、业务发展情况调整（包括取消、新增、减少、下架等）付费服务的类型和服务权益类型，我们可能将在服务页面或以其他方式公布和/或向您发送通知，我们建议请您仔细阅读。
       </p>
       <p>
        2.4 请您知悉，我们有权根据实际运营情况，向非付费用户或不同类型的付费用户，免费提供部分付费用户的权益。
       </p>
       <p>
        第三条 付费服务的获取与终止
       </p>
       <p>
        3.1 您可以在平台上的开通服务界面通过我们认可的支付方式完成支付来开通或购买付费服务。您在购买或开通服务时，应仔细核对帐号名称、开通服务类型、付费类型与服务期、注意事项等具体信息。<span class="bold">如因您个人原因造成充错帐号、开通错服务或时长，我们不予退还已收取的费用。</span>
       </p>
       <p>
        3.2 您应确保账号注册资料或其他您提供的信息的真实性，若您提供的信息不真实或不完整，则可能无法使用服务或在使用过程中受到限制。<span class="bold">如您的个人信息不真实而引起的不利后果，我们不承担责任。</span>
       </p>
       <p>
        3.3 您在此理解并同意，我们可能根据实际情况，对不同身份或不同阶段购买、订购或续费的付费用户给予不同的增值服务或资费，具体优惠政策以我们在相关服务页面公示的信息为准。
       </p>
       <p>
        3.4 我们可能会根据运营情况等，对付费服务的价格（包括单价和收费标准）进行调整，并在相关服务页面或其他合理方式通知您。若您在购买、订购和续费时，相关服务的价格发生了调整的，请以页面展示的现时有效的价格为准。
       </p>
       <p class="bold">
        3.5 特别提醒您，一切在非官方渠道获取的付费服务或相关权益，将无法得到我们的保护，我们有权单方收回并终止相应服务。
       </p>
       <p>
        3.6 付费服务仅限于购买帐号自行使用，且不能在不同帐号之间转移。
       </p>
       <p>
        <span class="bold">
            3.7 您知悉并理解，付费服务是一项特殊服务，若该付费服务有一定有效期，在已开通的付费服务有效期内，若您中途主动取消或终止资格的，将不会获得购买、开通费用的退还。除非法律另有规定，所有付费服务一经开通后不可转让或退款。
        </span>
        <span>
            付费服务资格取消/终止后，您不能再参加由我们组织的相应活动并不可再享有由我们提供的各项特权服务及增值服务，即我们不再为您提供相应的服务。
        </span>
       </p>
       <p>
        第四条 付费服务的使用规则
       </p>
       <p>
        4.1 您应妥善保存有关帐号、密码，并对该帐号进行的所有活动和行为负责，禁止赠与、借用、租用、转让或售卖该帐号。您应自行负责妥善保管、使用、维护您的帐号、帐号信息及帐号密码。<span class="bold">非我们原因致使您帐号密码泄漏以及因您保管、使用、维护不当造成损失的，我们无须承担与此有关的任何责任。</span>
       </p>
       <p class="bold">
        4.2 您开通付费服务后，可能会由于您使用的软件版本、设备、操作系统等的不同以及其他第三方原因导致您实际可使用的具体服务有一定差别，由此可能给您带来的不便，您表示理解且不予追究或豁免我们的相关责任。
       </p>
       <p class="bold">
        4.3 如您实施了下列行为之一，我们有完全的权利在不通知您的情况下，终止提供付费服务，并有权限制、冻结或终止与该服务相关联的帐号使用。我们无须给予任何补偿和退费，由此产生的责任由您自行独立承担。因此给我们或第三方造成损失的，您应负责全额赔偿：
       </p>
       <p class="bold">
        (1) 以营利为目的为自己或他人获得付费服务；
       </p>
       <p class="bold">
        (2) 将帐号以出租、出借、出售等任何形式提供给第三方使用；
       </p>
       <p class="bold">
        (3) 将通过付费服务获得的任何内容用于个人使用、娱乐之外的用途；
       </p>
       <p class="bold">
        (4) 盗用他人帐号进行注册或使用；
       </p>
       <p class="bold">
        (5) 以任何机器人软件、蜘蛛软件、爬虫软件、刷屏软件或其它非正规方式获得付费服务或参与任何活动；
       </p>
       <p class="bold">
        (6) 通过不正当手段或以违反诚实信用原则的行为获得付费服务、参与活动等。
       </p>
       <p class="bold">
        (7) 您的行为违反《用户协议》《内容生产服务协议》或《充值服务协议》等平台协议，或本协议内容或我们不时公布的活动规则和平台政策等内容；
       </p>
       <p class="bold">
        (8) 您的行为干扰了平台部分或功能的正常运行；
       </p>
       <p class="bold">
        (9) 您未经我们允许，利用平台开展未经我们同意的行为，包括但不限于附加广告、商业内容或链接等；
       </p>
       <p class="bold">
        (10) 您利用平台进行任何违法行为，或违反法律、法规、政策的规定，或违反公序良俗和社会公德。
       </p>
       <p>
        第五条 责任声明
       </p>
       <p class="bold">
        5.1 如果您购买或接受我们以外的第三方商户提供的商品或服务，如因此发生纠纷的，您应向销售或提供该商品或服务的第三方商户主张权利，与我们无关。
       </p>
       <p class="bold">
        5.2 我们不对您因第三方的行为或不作为造成的损失、不可抗力原因造成的损失承担任何责任，包括但不限于支付服务、网络接入服务、电信部门的通讯线路故障、通讯技术问题、网络、电脑故障、系统不稳定性、任意第三方的侵权行为等。
       </p>
       <p class="bold">
        5.3 您理解并同意，在使用付费服务的过程中，可能会遇到不可抗力等风险因素，使该服务发生中断。如出现上述情况，我们承诺将尽快与相关单位配合进行修复，但不承担由此对您造成的任何损失且不退还付费费用。
       </p>
       <p>
        第六条 其他约定
       </p>
       <p>
        <span class="bold">
            6.1 服务修改、中止、中断及终止：我们根据法律法规变化、自身商业决策、政府行为、不可抗力等原因可能会选择更改、中止、中断及终止全部或部分付费服务。如有此等情形发生，我们会通知您，但不承担由此对您造成的任何损失。
        </span>
        <span>
            我们对于发送给您所有的通知可能通过站内消息、网页公告、公众号通知、您预留的电子邮件、手机短信以及信件等方式进行。请您务必对我们发送的通知保持关注
        </span>
       </p>
       <p>
        6.2 如果协议的任何条款被认定为无效或不可执行，剩余协议条款仍然有效。
       </p>
    </div>
  </template>
  
  <script>
  // import {appActivityCreate} from "@/api/ranking";
  
  export default {
    name: 'agreement',
    data () {
      return {
        
      }
    },
    created() {
      
    },
    methods: {
      
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  h1{
      font-size: 40px;
      text-align: center;
      margin:20px 0;
  }
  p{
      font-size: 28px;
      text-indent:56px;
      color: rgba(0,0,0,.8);
  }
  .title{
      font-size: 32px;
      color: #000;
      font-weight: bold;
  }
  .bold{
      font-size: 28px;
      color: #000;
      font-weight: bold;
  }
  </style>
  